import { differenceInSeconds, isToday, format } from "date-fns";
import {
  COLOR_BLUE,
  COLOR_DARK_BLUE,
  COLOR_GREEN,
  COLOR_PINK,
  COLOR_PURPLE,
  COLOR_RED,
  COLOR_YELLOW,
} from "shared/theme/colors";

const colors = [
  COLOR_RED,
  COLOR_BLUE,
  COLOR_GREEN,
  COLOR_YELLOW,
  COLOR_PINK,
  COLOR_PURPLE,
  COLOR_DARK_BLUE,
];

export const getRandomColor = () => {
  return colors[Math.floor(Math.random() * colors.length)];
};

export const isLessThanOneMinute = (date: Date) =>
  differenceInSeconds(new Date(), date) < 60;

export const getMessageDate = (date: Date) => {
  const isJustNowMessage = isLessThanOneMinute(date);
  const isTodayMessage = isToday(date);
  if (isJustNowMessage) {
    return "Just now";
  }

  if (isTodayMessage) {
    return `Today ${format(date, "HH:mm")}`;
  }

  return format(date, "dd MMM yyyy, HH:mm");
};
